import { render } from "./MoveLeft.vue?vue&type=template&id=54795486"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/MoveLeft.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54795486"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54795486', __exports__)) {
    api.reload('54795486', __exports__)
  }
  
  module.hot.accept("./MoveLeft.vue?vue&type=template&id=54795486", () => {
    api.rerender('54795486', render)
  })

}


export default __exports__